import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import Disposisi from '../../../utilities/Disposisi';
import MasterService from '../../../services/master/MasterService';
import { AsyncPaginate } from 'react-select-async-paginate';
import SweetAlert from 'react-bootstrap-sweetalert';
import { getCurrentDateFormatted, romanNum } from '../../../utilities/Utils';
import TransaksiService from '../../../services/transaksi/TransaksiService';
import PbUmkuService from '../../../services/pbumku/PbumkuService';
import { FaEye } from 'react-icons/fa';
import GetDokumen from '../../../utilities/GetDokumen';

const ModalLapVerLap = ({ showAddLapVerLap, handleCloseAddLapVerLap, dataDisposisi, datappm, reloadList }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let masterService = useMemo(() => new MasterService(), [])
    let transaksiService = useMemo(() => new TransaksiService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [listKomponenVerlap, setListKomponenVerlap] = useState([])
    const [listPenugasanDetil, setListPenugasanDetil] = useState([])

    const [loadingSave, setLoadingSave] = useState(false)

    useEffect(() => {
        const getListKomponenVerlap = async () => {
            try {
                const response = await masterService.listKomponenVerlap(0, 20)
                setListKomponenVerlap(response.data.data)
            } catch (error) {
                console.log(error)
            }
        }
        getListKomponenVerlap()
    }, [masterService])

    useEffect(() => {
        if (!dataDisposisi) return
        const getSpp = async () => {
            try {
                const resSpp = await transaksiService.listPenugasan(datappm.nomorAju, 5, 0, 10)
                const resTugasDetil = await transaksiService.listPenugasanDetil(datappm.nomorAju, resSpp.data.data[0].noTugas)
                setListPenugasanDetil(resTugasDetil.data)
            } catch (error) {
                setListPenugasanDetil([])
            }
        }
        getSpp()
    }, [transaksiService, dataDisposisi, datappm])

    const [valueKesimpulanOpt, setValueKesimpulanOpt] = useState(null)

    async function loadOptionKesimpulan(search, loadedOption, { page = 1 }) {
        const response = await masterService.listKesimpulan('lhl', search, page - 1, 20)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeKesimpulan = e => {
        setValueKesimpulanOpt(e)
    }

    const [showConfirmSaveVerLap, setShowConfirmSaveVerLap] = useState(false)
    const handleCloseConfirmSaveVerLap = () => setShowConfirmSaveVerLap(false)
    const [showVerLapSuccess, setShowVerLapSuccess] = useState(false)
    const [showVerLapFailed, setShowVerLapFailed] = useState(false)
    const [rowVerLap, setRowVerLap] = useState(null)

    const SaveLapVerlap = (dataDisposisi) => {
        setShowConfirmSaveVerLap(true)
        setRowVerLap(dataDisposisi)
    }

    // const [selectedRadio, setSelectedRadio] = useState(null)
    const [stsProduk, setStsProduk] = useState('')
    const [stsSpecies, setStsSpecies] = useState('')
    const handleChangeRadio = (e) => {
        // console.log(e)
        let targetId = e.target.id
        let splitString = targetId.split('_')
        let targetString = splitString[1]
        // console.log(targetString)
        switch (targetString) {
            case 'stsProduk':
                setStsProduk(e.target.value)
                break;
            case 'stsSpecies':
                setStsSpecies(e.target.value)
                break;
            default:
                break;
        }
        // setSelectedRadio(e.target.value)
    }

    const handleClickSaveVerLap = async () => {
        setLoadingSave(true)
        try {
            let dataPpm = ''

            const respNomor = await pbumkuService.ambilNomorService('PPM_SPT_LT', datappm.kdUpt, currentYear, localStorage.getItem('username'))
            // let noSuratTugasTemp = datappm.kdUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + Math.floor(100000 + Math.random() * 900000)
            let noSuratTugasTemp = respNomor.data.uraianPusat + '/' + respNomor.data.kodePusat + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut

            let jsonVerLap = { ...rowVerLap, noTugas: noSuratTugasTemp, tglTugas: getCurrentDateFormatted(), createdBy: localStorage.getItem('userId'), createdAt: new Date() }
            const resVerLap = await transaksiService.addPenugasan(jsonVerLap)
            if (resVerLap.data.kode === '200') {
                let jsonHasilVerLap = {
                    nomorAju: datappm.nomorAju,
                    tglTugas: dataDisposisi.tglTugas,
                    nipInspektur: listPenugasanDetil[0].nipPetugas,
                    stsProduk: stsProduk,
                    stsSpecies: stsSpecies,
                    idKesimpulan: valueKesimpulanOpt.idKesimpulan,
                    kseimpulan: valueKesimpulanOpt.kesimpulan,
                    disposisi: valueKesimpulanOpt.idDisposisi,
                    dateCreate: getCurrentDateFormatted(),
                    operator: localStorage.getItem('userId')
                }
                await transaksiService.addHasilVerLapangan(jsonHasilVerLap)

                if (valueKesimpulanOpt.idDisposisi === '9') {
                    let jsonSppDraftHc = { idDisposisi: 4, nomorAju: datappm.nomorAju }
                    // let jsonSKHC = { idDisposisi: 9, nomorAju: datappm.nomorAju }
                    // let jsonPnbp = { idDisposisi: 10, nomorAju: datappm.nomorAju }
                    // let jsonHC = { idDisposisi: 11, nomorAju: datappm.nomorAju }

                    await transaksiService.addPenugasan(jsonSppDraftHc)
                    // await transaksiService.addPenugasan(jsonSKHC)
                    // await transaksiService.addPenugasan(jsonPnbp)
                    // await transaksiService.addPenugasan(jsonHC)

                    dataPpm = { ...datappm, status: '025' }
                } else {
                    dataPpm = { ...datappm, status: '110' }
                }
                await transaksiService.addPpm(dataPpm)
                setShowVerLapSuccess(true)
                setShowConfirmSaveVerLap(false)
            }
        } catch (error) {
            console.log(error)
            setShowVerLapFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickVerLapSuccess = () => {
        setShowVerLapSuccess(false)
        // window.location.reload()
        reloadList(0, 10)
    }

    const handleClickVerLapFailed = () => {
        setShowVerLapFailed(false)
    }

    const [showOpenPreview, setShowOpenPreview] = useState(false)
    const handleClosePreview = () => {
        setBase64String(null)
        setShowOpenPreview(false)
    }

    const [base64String, setBase64String] = useState(null)

    const handleClickPreviewDok = async (idJnsDok, nomorAju) => {
        try {
            // console.log(idJnsDok)
            // console.log(nomorAju)
            const resDok = await transaksiService.getPpmDokByAjuKodeDok(nomorAju, idJnsDok)
            // console.log(resDok)
            if (resDok.data !== '') {
                setBase64String(resDok.data.dokPath)
                setShowOpenPreview(true)
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Modal
                show={showAddLapVerLap}
                onHide={handleCloseAddLapVerLap}
                backdrop='static'
                keyboard={false}
                size='xl'
                centered
            >
                <Modal.Header><h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6></Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        {
                            listKomponenVerlap.map((komp, index) => {
                                return (
                                    <>
                                        <div key={index} className='row mb-3'>
                                            <label className='col-sm-1 col-form-label-sm'>{index + 1}</label>
                                            <div className="col-sm-4">
                                                <input type="text" className="col-sm-12 form-control-sm" name="komponen" defaultValue={komp.komponen} readOnly />
                                            </div>
                                            <div className="col-sm-2">
                                                {/* <input type="text" className="col-sm-12 form-control-sm" name="dokwajib" defaultValue={GetNomorDok(dokwajib.idJnsDok)} readOnly /> */}
                                                <GetDokumen nomorAju={datappm.nomorAju} idJnsDok={komp.tipe} />
                                            </div>
                                            <div className='col-sm-3'>
                                                {/* <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id={"flexSwitchCheckChecked" + index} />
                                                    <label class="form-check-label" for={"flexSwitchCheckChecked" + index}>Sesuai</label>
                                                </div> */}
                                                <div className="col-sm-12">
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input" type="radio" name={'inlineRadio' + komp.field} id={'inlineRadio' + komp.field} value="1" onChange={handleChangeRadio} />
                                                        <label class="form-check-label" for={'inlineRadio' + komp.field}>Sesuai</label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input" type="radio" name={'inlineRadio' + komp.field} id={'inlineRadio' + komp.field} value="0" onChange={handleChangeRadio} />
                                                        <label class="form-check-label" for={'inlineRadio' + komp.field}>Tidak Sesuai</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-sm-2'>
                                                <OverlayTrigger placement="bottom" overlay={
                                                    <Tooltip >Preview Dokumen</Tooltip>
                                                }>
                                                    <Button size="sm" variant="outline-info" onClick={() => handleClickPreviewDok(komp.tipe, datappm.nomorAju)}>
                                                        <FaEye /> Preview
                                                    </Button>
                                                </OverlayTrigger>{' '}
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                    <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">Rekomendasi</label>
                        <div className='col-sm-8'>
                            <AsyncPaginate
                                loadOptions={loadOptionKesimpulan}
                                value={valueKesimpulanOpt}
                                getOptionLabel={(option) => option.kesimpulan}
                                getOptionValue={(option) => option.idKesimpulan}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeKesimpulan}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => SaveLapVerlap(dataDisposisi)}>Simpan</Button>{' '}
                    <Button variant="secondary" size="sm" onClick={handleCloseAddLapVerLap}>Close</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSaveVerLap &&
                <SweetAlert
                    title="Proses Laporan Evaluasi Teknis?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSaveVerLap}
                    onCancel={handleCloseConfirmSaveVerLap}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showVerLapSuccess &&
                <SweetAlert
                    title="Laporan Evaluasi Teknis Berhasil Disimpan"
                    success
                    onConfirm={handleClickVerLapSuccess}
                    btnSize="sm"
                />
            }
            {
                showVerLapFailed &&
                <SweetAlert
                    title="Laporan Evaluasi Teknis Gagal Disimpan"
                    danger
                    onConfirm={handleClickVerLapFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            <PreviewPdf showOpenPreview={showOpenPreview} handleClosePreview={handleClosePreview} base64string={base64String} />
        </>
    )
}

const PreviewPdf = ({ showOpenPreview, handleClosePreview, base64string }) => {
    // const pdfUrl = 'data:application/pdf;base64,' + base64string

    return (
        <>
            <Modal show={showOpenPreview} onHide={handleClosePreview} size='xl'>
                <iframe
                    src={base64string}
                    title='Preview PDF'
                    width="100%"
                    height="800px"
                ></iframe>
            </Modal>
        </>
    )
}

export default ModalLapVerLap